import React from 'react';
import HubblePageContainer from './components/HubblePageContainer';
import HubbleScoreList from './components/HubbleScoreList';
import HubblePudium from './components/HubblePudium';
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

const HubbleScoreBoard = () => {
  const navigate  = useNavigate()
  return (
    <HubblePageContainer>
      <div className='d-flex justify-content-between align-items-center py-2'>
        <div>
          <h4>امتیازات</h4>
        </div>
        <div onClick={() => navigate(-1)} >
          <FaArrowLeftLong size={20} />
        </div>
      </div>
      <HubblePudium />
      <section className='my-4'>
        <HubbleScoreList />
      </section>
    </HubblePageContainer>
  )
}

export default HubbleScoreBoard